import { getBrandsModels, setBrands } from 'localStorage/dataStorage';
import {
	Brand,
	CreateBrandDto,
} from 'models/inventory/interfaces/brand.interface';
import {
	axiosErrorHandler,
	get,
	post,
} from 'models/shared/helpers/axiosInstance';

export const getBrandsWithModels = async (forceRefresh = false) => {
	try {
		let info = forceRefresh ? null : getBrandsModels();
		if (!info) {
			const res = await get<Brand[]>('v1/brand');
			info = res.data;
			setBrands(info);
		}
		return info;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createBrand = async (dto: CreateBrandDto) => {
	try {
		const res = await post<Brand>('v1/brand', dto);
		setBrands(null as any);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
